export default {
  namespaced: true,
  state: {
    showNewPlayer: false,
    showNewArbitro: false,
    showNewUser: false,
    showConfigurationGroup: false,
    showUpdateMatch: false,
    showNewInstitucion: false,
    showUploadExcel: false,
    showUploadExcelTecnica: false,
    showNewEquipo: false,
    showNewCategoria: false,
    showNewSancion: false,
    showNewDelegado: false,
    showNewSancionRead: false,
    showDividirMulta: false,
    showTablaPosiciones: false,
    showConfirmacionInscripcion: false,
    showConfirmacionArbitro: false,
    showNewValorFijo: false,
    showNewTipoAlterno: false,
    showOrdenarReglamento: false,
    showMultas: false,
    showDarBajaMulta: false,
    activateRevision: false,
    activateSancionPendiente: false,
    equipoRevision: {},
    actionPlayer: 'INSERT',
    actionArbitro: 'INSERT',
    actionDelegado: 'INSERT',
    sancion: {},
    showNewTarjetaDictamen: false,
    showModalRecibo: false,
    showMultaGlobal: false,
    showModalLog: false,
    showModalDetalleRecibo: false,
    showConfirmacionRevisarPartido: false,
    showConfirmacionFinalizarEtapa: false,
    showNuevoHistorial: false,
    showConfirmacionLog: false,
    showConfirmacionDelegado: false,
    showConfigEspejo: false,
    showSemanasTesoreria: false,
    showNewNoticia: false,
    showHistorial: false,
    showPaseModal: false,
    showNewMotivo: false,
    showPrintProgramacion: false,
    showModalEtapas: false,
    showHistorialPlayer: false,
    showPendientes: false,
    showConsentimiento: false,
    showModifyTable: false,
    showTablaGoleadores: false,
    showNewConfigPago: false,
    showNewPago: false,
    showNewAuxiliar: false,
    showRespaldos: false,
    showDocumentos: false,
    showPartidoTesoreria: false,
    showNewTarea: false,
    showConfigAcumulada: false,
    showConfigResetTa: false,
    showModalHorarios: false,
    showModalCanchas: false,
    showDeleteFixture: false,
    showGenerarConfirmacion: false,
    updatePerfil: {},
    ubicacionActual: '',
    torneoSeleccionado: {},
    listEstadisticas: [],
  },
  getters: {
    getActionPlayer: state => {
      const { actionPlayer } = state
      return actionPlayer
    },
    getActionArbitro: state => {
      const { actionArbitro } = state
      return actionArbitro
    },
    getActionDelegado: state => {
      const { actionDelegado } = state
      return actionDelegado
    },
    getActivateRevision: state => {
      const { activateRevision } = state
      return activateRevision
    },
    getSancionPendiente: state => {
      const { activateSancionPendiente } = state
      return activateSancionPendiente
    },
    getEquipoRevision: state => {
      const { equipoRevision } = state
      return equipoRevision
    },
    getSancion: state => {
      const { sancion } = state
      return sancion
    },
    getUbicacion: state => {
      const { ubicacionActual } = state
      return ubicacionActual
    },
    getTorneoSeleccionado: state => {
      const { torneoSeleccionado } = state
      return torneoSeleccionado
    },
    getUpdatePerfil: state => {
      const { updatePerfil } = state
      return updatePerfil
    },
    getListEstadisticas: state => {
      const { listEstadisticas } = state
      return listEstadisticas
    },
    getStateShowNewSancion: state => {
      const { showNewSancion } = state
      return showNewSancion
    },
  },
  mutations: {
    UPDATE_SHOW_NEW_PLAYER(state, val) {
      state.showNewPlayer = val
    },
    UPDATE_SHOW_NEW_USER(state, val) {
      state.showNewUser = val
    },
    UPDATE_SHOW_RECIBO(state, val) {
      state.showModalRecibo = val
    },
    UPDATE_ACTION_PLAYER(state, val) {
      state.actionPlayer = val
    },
    UPDATE_ACTION_ARBITRO(state, val) {
      state.actionArbitro = val
    },
    UPDATE_ACTION_DELEGADO(state, val) {
      state.actionDelegado = val
    },
    UPDATE_ACTION_CONFIGURATION_GROUP(state, val) {
      state.showConfigurationGroup = val
    },
    // UPDATE_SHOW_UPDATE_GROUP(state, val) {
    //   state.showUpdateMatch = val
    // },
    UPDATE_SHOW_UPDATE_MATCH(state, val) {
      state.showUpdateMatch = val
    },
    UPDATE_SHOW_MULTAS(state, val) {
      state.showMultas = val
    },
    UPDATE_SHOW_UPLOAD_EXCEL(state, val) {
      state.showUploadExcel = val
    },
    UPDATE_ACTIVATE_REVISION(state, val) {
      state.activateRevision = val
    },
    UPDATE_ACTIVATE_SANCION_PENDIENTE(state, val) {
      state.activateSancionPendiente = val
    },
    UPDATE_ACTIVATE_EQUIPO_REVISION(state, val) {
      state.equipoRevision = val
    },
    UPDATE_SANCION(state, val) {
      state.sancion = val
    },
    UPDATE_SHOW_NEW_INSTITUCION(state, val) {
      state.showNewInstitucion = val
    },
    UPDATE_SHOW_NEW_EQUIPO(state, val) {
      state.showNewEquipo = val
    },
    UPDATE_SHOW_NEW_SANCION(state, val) {
      state.showNewSancion = val
    },
    UPDATE_SHOW_NEW_SANCION_READ(state, val) {
      state.showNewSancionRead = val
    },
    UPDATE_SHOW_TABLA_POSICIONES(state, val) {
      state.showTablaPosiciones = val
    },
    UPDATE_SHOW_CONFIRMACION_INSCRIPCION(state, val) {
      state.showConfirmacionInscripcion = val
    },
    UPDATE_SHOW_CONFIRMACION_ARBITRO(state, val) {
      state.showConfirmacionArbitro = val
    },
    UPDATE_SHOW_TARJETA_DICTAMEN(state, val) {
      state.showNewTarjetaDictamen = val
    },
    UPDATE_UBICACION_ACTUAL(state, val) {
      state.ubicacionActual = val
    },
    UPDATE_TORNEO_SELECCIONADO(state, val) {
      state.torneoSeleccionado = val
    },
    UPDATE_SHOW_TABLA_GOLEADORES(state, val) {
      state.showTablaGoleadores = val
    },
    UPDATE_SHOW_DIVIDIR_MULTA(state, val) {
      state.showDividirMulta = val
    },
    UPDATE_SHOW_MODAL_LOG(state, val) {
      state.showModalLog = val
    },
    UPDATE_SHOW_CONFIRMA_PARTIDO_REVISADO(state, val) {
      state.showConfirmacionRevisarPartido = val
    },
    UPDATE_SHOW_CONFIRMACION_LOG(state, val) {
      state.showConfirmacionLog = val
    },
    UPDATE_SHOW_NEW_NOTICIA(state, val) {
      state.showNewNoticia = val
    },
    UPDATE_SHOW_NEW_PAGO(state, val) {
      state.showNewPago = val
    },
    UPDATE_SHOW_HISTORIAL(state, val) {
      state.showHistorial = val
    },
    UPDATE_SHOW_PASE_MODAL(state, val) {
      state.showPaseModal = val
    },
    UPDATE_SHOW_SEMANA_TESORERIA(state, val) {
      state.showSemanasTesoreria = val
    },
    UPDATE_SHOW_SLOTS(state, val) {
      state.showConfirmacionFinalizarEtapa = val
    },
    UPDATE_PERFIL(state, val) {
      state.updatePerfil = val
    },
    UPDATE_SHOW_MULTA_GLOBAL(state, val) {
      state.showMultaGlobal = val
    },
    UPDATE_SHOW_PRINT_PROGRAMACION(state, val) {
      state.showPrintProgramacion = val
    },
    UPDATE_SHOW_MODAL_ETAPAS(state, val) {
      state.showModalEtapas = val
    },
    UPDATE_SHOW_NEW_ARBITRO(state, val) {
      state.showNewArbitro = val
    },
    UPDATE_SHOW_NEW_MOTIVO(state, val) {
      state.showNewMotivo = val
    },
    UPDATE_SHOW_HISTORIAL_PLAYER(state, val) {
      state.showHistorialPlayer = val
    },
    UPDATE_SHOW_PENDIENTES(state, val) {
      state.showPendientes = val
    },
    UPDATE_SHOW_CONSENTIMIENTO(state, val) {
      state.showConsentimiento = val
    },
    UPDATE_SHOW_MODIFY_TABLE(state, val) {
      state.showModifyTable = val
    },
    UPDATE_LIST_ESTADISTICAS(state, val) {
      state.listEstadisticas = val
    },
    UPDATE_SHOW_NEW_CATEGORIA(state, val) {
      state.showNewCategoria = val
    },
    UPDATE_SHOW_NEW_AUXILIAR(state, val) {
      state.showNewAuxiliar = val
    },
    UPDATE_SHOW_NEW_CONFIG_PAGO(state, val) {
      state.showNewConfigPago = val
    },
    UPDATE_SHOW_CONFIG_ESPEJO(state, val) {
      state.showConfigEspejo = val
    },
    UPDATE_SHOW_UPLOAD_EXCEL_TECNICA(state, val) {
      state.showUploadExcelTecnica = val
    },
    UPDATE_SHOW_ORDENAR_REGLAMENTO(state, val) {
      state.showOrdenarReglamento = val
    },
    UPDATE_SHOW_RESPALDOS(state, val) {
      state.showRespaldos = val
    },
    UPDATE_SHOW_PARTIDO_TESORERIA(state, val) {
      state.showPartidoTesoreria = val
    },
    UPDATE_SHOW_NEW_VALOR_FIJO(state, val) {
      state.showNewValorFijo = val
    },
    UPDATE_SHOW_NEW_TIPO_ALTERNO(state, val) {
      state.showNewTipoAlterno = val
    },
    UPDATE_SHOW_NEW_TAREA(state, val) {
      state.showNewTarea = val
    },
    UPDATE_SHOW_MODAL_DETALLE_RECIBO(state, val) {
      state.showModalDetalleRecibo = val
    },
    UPDATE_SHOW_CONFIG_ACUMULADA(state, val) {
      state.showConfigAcumulada = val
    },
    UPDATE_SHOW_CONFIG_RESET_TA(state, val) {
      state.showConfigResetTa = val
    },
    UPDATE_SHOW_MODAL_HORARIOS(state, val) {
      state.showModalHorarios = val
    },
    UPDATE_SHOW_DELETE_FIXTURE(state, val) {
      state.showDeleteFixture = val
    },
    UPDATE_SHOW_GENERAR_CONFIRMACION(state, val) {
      state.showGenerarConfirmacion = val
    },
    UPDATE_SHOW_MODAL_CANCHAS(state, val) {
      state.showModalCanchas = val
    },
    UPDATE_SHOW_NUEVO_HISTORIAL(state, val) {
      state.showNuevoHistorial = val
    },
    UPDATE_SHOW_NEW_DELEGADO(state, val) {
      state.showNewDelegado = val
    },
    UPDATE_SHOW_CONFIRMACION_DELEGADO(state, val) {
      state.showConfirmacionDelegado = val
    },
    UPDATE_SHOW_DAR_BAJA_MULTA(state, val) {
      state.showDarBajaMulta = val
    },
    UPDATE_SHOW_DOCUMENTOS(state, val) {
      state.showDocumentos = val
    },
  },
}
